import LandingHeader from './LandingHeader';

export default LandingHeader;
